var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._b({attrs:{"headers":_vm.headers,"items":_vm.quoteServiceTemplates,"item-key":"id","loading":_vm.loading,"items-per-page":-1,"footer-props":{
    showFirstLastPage: true,
    itemsPerPageOptions: [25]
  }},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('ErrorAlert',{staticClass:"mb-0",attrs:{"dense":"","error-message":_vm.errorMessage,"detail-error-message":_vm.detailErrorMessage},on:{"clearErrors":_vm.clearAllErrors}}),_vm._t("top")]},proxy:true},{key:"item.note",fn:function(ref){
  var value = ref.value;
return [_c('QuoteTemplateNoteTooltipIcon',{attrs:{"note":value}})]}},{key:"item.index",fn:function(ref){
  var item = ref.item;
return [_vm._t("item.index",[_vm._v(" "+_vm._s(_vm.quoteServiceTemplates.indexOf(item) + 1)+" ")],null,{ item: item })]}},{key:"item.actions",fn:function(ref){
  var item = ref.item;
return [_vm._t("item.actions",null,null,item)]}}],null,true)},'v-data-table',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }